import { render, staticRenderFns } from "./PolicyStatusFilter.vue?vue&type=template&id=722001eb"
import script from "./PolicyStatusFilter.vue?vue&type=script&lang=ts"
export * from "./PolicyStatusFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports